import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwitchIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	width: 24,
	fill: "#111",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17 12.3 16.275 11.6 19.375 8.5H3.5V7.5H19.375L16.275 4.4L17 3.7L21.3 8ZM7 20.3 2.7 16 7 11.7 7.725 12.4 4.625 15.5H20.5V16.5H4.625L7.725 19.6Z" })
});
export { SvgSwitchIcon as ReactComponent };
